import React from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AddBoxIcon from '@mui/icons-material/AddBox';

const AddCrature = (props) => {
  return (
    <Button
        variant={variant(props)}
        onClick={props.plus}
        color={color(props)}
        >
        {icon(props)}
        &nbsp;  {props.addLabel}
    </Button>
  );
}

const color = (props) => {
  if (props.color) {
    return props.color;
  }

  return "primary";
}

const variant = (props) => {
  if (props.variant) {
    return props.variant;
  }

  return "contained";
}

const icon = (props) => {
  if (props.variant == "text") {
    return <AddBoxIcon />;
  }
  return <AddIcon />;
}

export default AddCrature;
